
import { gettersInstance, propsInstance } from "@/lib/util";
import { apiCall } from "@/lib/api";
import { formatDate } from "../../lib/util";
import { Component, MixedVue } from "@/vue";
import { mixins } from "vue-class-component";
import { Farm } from "@/lib/types/Farm";
import EventBus from "@/lib/event-bus";

interface FarmMenuItemProps {
  farm: Farm;
}

const Props = propsInstance<FarmMenuItemProps>({
  farm: {
    type: Object,
    required: true,
  },
});

const StoreGetters = gettersInstance([
  "rasterKind",
  "farms",
  "currentFarmId",
  "selectedParcelId",
  "demoFarmId",
  "userEmail",
  "selectedDate",
  "currentSeasonId",
  "userLicenseIsTrial",
  "parcelsForSeason",
  "isDemoFarm",
]);

@Component({
  name: "FarmMenuItem",
})
export default class FarmMenuItem extends mixins(MixedVue, Props, StoreGetters) {
  get parcelCount() {
    return this.farm.parcelAccessOnly ? this.farm.sharedParcels.length : this.farm.parcel_count;
  }

  get matchedComponent() {
    if (!this.$route || this.$route.matched.length == 0) return null;
    //@ts-ignore
    return this.$route.matched[0].components?.default?.name;
  }

  get defaultRouteParams() {
    return {
      farmId: this.currentFarmId,
      seasonId: this.currentSeasonId || null,
      date: this.selectedDate ? formatDate(this.selectedDate) : null,
    };
  }

  get isJournalUser() {
    return this.$store.getters.user.groups.some((group) => group.name === "Journal users");
  }

  async requestFarmAccess() {
    try {
      await apiCall("POST", `/shared-farms/${this.farm.id}/request_access/`);
      this.notify({
        type: "success",
        icon: "person",
        text: this.$gettext("A request for access has been sent to the farm owner."),
      });
    } catch (e) {
      this.notify({
        type: "error",
        text: this.$gettext("Unable to requests access to farm."),
      });
    }
  }

  showJournalDialog() {
    EventBus.$emit("showJournalDialog", true);
  }
}
